const STANDARD_CONVERSION = {
  mode: "standard",
  eyebrow: "Keep the result",
  title: "Need to know what actually affects the property?",
  summary: "A professional review can confirm the parcel boundary, zoning, local records, and whether the mapped conditions matter to the decision in front of you.",
  cta: "Get this property professionally reviewed"
};

const MANUAL_FLOOD_CONVERSION = {
  mode: "manual-flood-review",
  eyebrow: "Automated flood check unavailable",
  title: "The FEMA check needs to be completed manually.",
  summary: "This result does not mean the property is outside a mapped flood hazard area. LandSage can manually review the effective FEMA map and available state and local floodplain records, then explain what is known, what remains unresolved, and what should happen next.",
  cta: "Request a manually completed flood and property review"
};

export function getReviewConversion(snapshot = {}) {
  const floodFinding = snapshot.findings?.find(item => item.key === "flood");
  const femaSource = snapshot.sources?.find(source => /^FEMA\b/i.test(source.name || ""));
  const floodCheckUnresolved = floodFinding?.status === "unknown" || femaSource?.status === "unavailable";
  return floodCheckUnresolved ? MANUAL_FLOOD_CONVERSION : STANDARD_CONVERSION;
}
